/* AP 6.0 — fiche produit (zone B). Sans dépendance ; s'appuie sur ap-frame.js (window.AP) et les composants Dawn
   (variant-selects, product-form). Le cadre reste porté par l'app Globo (rendue invisible) : nos boutons Cadre cliquent
   le label Globo du groupe du format courant (inputs frame-m|l|xl, attribut original-value = libellé FR).
   Événement émis à chaque changement : document « ap:pdp » { size, frame, variant, unit, qty } (écouté par « Compléter votre mur »
   et la barre collante). */
(function () {
  'use strict';
  var AP = (window.AP = window.AP || {});
  var NB = ' ';
  /* scènes « au mur » (photos 1600×900) : cx = centre du meuble (% largeur), k = % de la largeur pour 1 cm,
     top = haut du meuble (% hauteur), gap = meuble → bas du cadre (cm), h = hauteur de la scène dans la galerie (%), wall = mur prolongé */
  var SCENES = [
    { w: 210, cx: 49, k: 0.318, top: 50.6, gap: 20, h: 68, wall: 'linear-gradient(90deg,#e1d7ca,#ddd5c1 20%,#dad1bd 30%,#d5cdb9 40%,#cec4b1 50%,#c7bdaa 60%,#c0b5a5 70%,#b9b09f 85%)' },
    { w: 170, cx: 50, k: 0.267, top: 54.2, gap: 20, h: 66, wall: 'linear-gradient(90deg,#cdc5b1,#cdc3ad 20%,#c9bea9 30%,#c2b7a4 40%,#baae96 50%,#b3a691 60%,#aca088 70%,#a99a84 85%)' },
    { w: 140, cx: 50.4, k: 0.44, top: 38, gap: 20, h: 60, wall: 'linear-gradient(90deg,#f2ead6,#ece0bd 20%,#e8d5ae 30%,#e1d2b0 40%,#d9ccab 50%,#cebf9e 60%,#c9b99a 70%,#bdae8e 80%,#b5a48c 90%)' }
  ];
  var money = function (c) { return AP.money ? AP.money(c) : (c / 100).toFixed(2) + ' €'; };
  var fp = function (size, id) { return id && AP.framePrice ? AP.framePrice(size, id) : 0; };
  var frameName = function (id) { var F = window.AP_FRAMES; return (F && F.names && F.names[id || '']) || id; };
  /* le filtre | t échappe les clés non _html (« l&#39;impression ») : on décode une fois les textes de config */
  var decTa = document.createElement('textarea');
  function decode(o) {
    if (typeof o === 'string') { decTa.innerHTML = o; return decTa.value; }
    if (o && typeof o === 'object') Object.keys(o).forEach(function (k) { o[k] = decode(o[k]); });
    return o;
  }
  var sub = function (s) { var a = arguments; return String(s || '').replace(/%(\d)/g, function (m, i) { return a[+i] !== undefined ? a[+i] : ''; }); };

  /* ---------- pont Globo ---------- */
  function globoInputs(size) { return Array.prototype.slice.call(document.querySelectorAll('.gpo-app input[name="frame-' + size + '"]')); }
  function globoValue(i) { return i.getAttribute('original-value') || i.value; }
  function globoTarget(size, id) {
    /* original-value = libellé FR de Globo ; AP_FRAMES.labels est dans la langue courante → on compare les identifiants */
    return globoInputs(size).filter(function (i) { return AP.cadreId(globoValue(i)) === (id || ''); })[0];
  }
  function globoClick(input) {
    var lab = input.id ? document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]') : null;
    (lab || input.closest('label') || input).click();
  }
  /* synchro immédiate ; renvoie false si le groupe Globo du format n'est pas (encore) prêt */
  function globoSync(size, id) {
    var ins = globoInputs(size);
    if (!ins.length) return false;
    var el = ins[0].closest('.gpo-element');
    if (el && getComputedStyle(el).display === 'none') return false;
    var cur = ins.filter(function (i) { return i.checked; })[0];
    if (!id && !cur) return true;
    var t = globoTarget(size, id);
    if (!t) return false;
    if (!t.checked) globoClick(t);
    return true;
  }

  function initPdp(root) {
    var sid = root.dataset.section;
    var cfgEl = document.getElementById('ApPdpConfig-' + sid);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var S = decode(cfg.str), mode = cfg.mode, posterish = mode !== 'standard';
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var byId = function (id) { return cfg.variants.filter(function (v) { return String(v.id) === String(id); })[0]; };
    var params = new URLSearchParams(location.search);
    var st = { variant: byId(cfg.current) || cfg.variants[0], frame: '', qty: 1, view: 0, wall: false, scene: 0, orient: 'p' };
    var pf = AP.cadreId(params.get('cadre') || params.get('f') || '');
    if (pf && posterish) st.frame = pf;
    var form = document.getElementById('product-form-' + sid);
    var idInput = form && form.querySelector('input[name="id"]');
    var addBtn = document.getElementById('ProductSubmitButton-' + sid);
    var sizeInput = function (k) { return $('input[data-ap-size="' + k + '"]'); };
    var dimsOf = function (k) { var i = sizeInput(k); return i ? i.dataset.apDims.split('x').map(Number) : [30, 42]; };
    var framesBox = $('[data-ap-frames]');
    $$('[data-ap-money]').forEach(function (e) { e.textContent = money(+e.dataset.apMoney); });
    var framesReady = false;

    function unit() { return st.variant.p + (posterish ? fp(st.variant.s, st.frame) : 0); }

    /* ---------- prix, libellés ---------- */
    function update(bump) {
      var v = st.variant, u = unit(), tot = u * st.qty, add = posterish ? fp(v.s, st.frame) : 0;
      $$('[data-ap-price]').forEach(function (e) {
        e.textContent = money(tot);
        if (bump) { e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); }
      });
      $$('[data-ap-fxtotal]').forEach(function (e) { e.setAttribute('data-ap-eur', tot); });
      var pd = $('[data-ap-pdetail]');
      if (pd && posterish) pd.textContent = st.qty > 1 ? sub(S.qty_x, st.qty, money(u)) : (add ? sub(S.poster_plus_frame, money(v.p), money(add).replace(/[.,]00(?=\D*$)/, '')) : S.poster_only);
      $$('[data-ap-lot]').forEach(function (e) { e.innerHTML = sub(S.lot, money(u * 2)); });
      $$('[data-ap-addprice]').forEach(function (e) { e.textContent = NB + '· ' + money(tot); });
      if (posterish) {
        var d = dimsOf(v.s);
        $$('[data-ap-size-lbl]').forEach(function (e) { e.textContent = '· ' + v.s.toUpperCase() + ' · ' + d[0] + NB + '×' + NB + d[1] + NB + 'cm'; });
        $$('[data-ap-frame-lbl]').forEach(function (e) { e.textContent = '· ' + frameName(st.frame); });
        $$('[data-ap-size-price]').forEach(function (e) {
          var k = e.dataset.apSizePrice, vv = cfg.variants.filter(function (x) { return x.s === k; })[0];
          if (vv) e.textContent = money(vv.p + fp(k, st.frame));
        });
        $$('[data-ap-frame-price]').forEach(function (e) {
          var id = e.dataset.apFramePrice; if (id) e.textContent = '+' + money(fp(v.s, id)).replace(/[.,]00(?=\D*$)/, '');
        });
        $$('[data-ap-spec-roll],[data-ap-spec-adh]').forEach(function (e) { e.hidden = !!st.frame; });
        $$('[data-ap-spec-framed]').forEach(function (e) { e.hidden = !st.frame; });
        $$('[data-ap-frame]').forEach(function (b) {
          var on = b.dataset.apFrame === st.frame;
          b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      } else {
        $$('[data-ap-optval]').forEach(function (e) {
          var i = +e.dataset.apOptval, val = (v.t || '').split(' / ')[i];
          if (val) e.textContent = '· ' + val;
        });
      }
      if (mode === 'poster') { renderWall(); galFoot(); }
      if (mode === 'perso') perso.paint();
      var q = $('[data-ap-qty="-1"]'); if (q) q.disabled = st.qty <= 1;
      document.dispatchEvent(new CustomEvent('ap:pdp', { detail: { section: sid, size: v.s, frame: st.frame, variant: v, unit: u, qty: st.qty, title: cfg.title } }));
      if (posterish) setTimeout(syncUrl, 0);
    }
    /* le cadre choisi va dans l'URL (?cadre=) : retour arrière / avance / partage du lien gardent le cadre
       (le format y est déjà via ?variant=). setTimeout : après le replaceState de Dawn au changement de format. */
    function syncUrl() {
      try {
        var u = new URL(location.href);
        if ((u.searchParams.get('cadre') || '') === st.frame) return;
        u.searchParams.delete('f');
        if (st.frame) u.searchParams.set('cadre', st.frame); else u.searchParams.delete('cadre');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    /* ---------- format : <variant-selects> (Dawn) met à jour input[name=id] puis on suit ---------- */
    function onVariant() {
      var v = idInput && byId(idInput.value);
      if (!v || v === st.variant) return;
      var sizeChanged = v.s !== st.variant.s;
      st.variant = v;
      if (posterish && sizeChanged) applyFrame();
      if (mode === 'standard' && v.m) showMedia(v.m);
      update(true);
    }
    if (idInput) idInput.addEventListener('change', onVariant);
    root.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) setTimeout(onVariant, 0); });

    /* ---------- cadre ---------- */
    var applyTimer = null;
    function applyFrame(tries) {
      clearTimeout(applyTimer);
      tries = tries || 0;
      if (!posterish || !framesBox) return;
      if (globoSync(st.variant.s, st.frame)) { framesReady = true; return; }
      if (tries < 40) applyTimer = setTimeout(function () { applyFrame(tries + 1); }, 150);
    }
    function setFrame(id) {
      st.frame = id || '';
      if (mode === 'poster') {
        $$('[data-ap-main],[data-ap-tmain],.ap-wp').forEach(function (r) { AP.setCadre(st.frame, r); });
        if (!st.wall) showView(0);
      }
      applyFrame();
      update(true);
    }
    $$('[data-ap-frame]').forEach(function (b) {
      b.addEventListener('click', function () { setFrame(b.dataset.apFrame); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var all = $$('[data-ap-frame]'), i = all.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
        var n = all[(i + all.length) % all.length]; n.focus(); n.click(); e.preventDefault();
      });
    });
    /* sans widget Globo (app absente sur ce produit) : pas de choix de cadre */
    if (framesBox) {
      var waited = 0, iv = setInterval(function () {
        waited += 250;
        if (document.querySelector('.gpo-app input[name^="frame-"]')) { clearInterval(iv); if (st.frame) applyFrame(); return; }
        if (waited > 9000) { clearInterval(iv); framesBox.hidden = true; if (st.frame) setFrame(''); }
      }, 250);
    }
    /* juste avant l'ajout : on revérifie que Globo porte bien le cadre affiché */
    if (addBtn && posterish) addBtn.addEventListener('click', function () { if (framesBox && !framesBox.hidden) globoSync(st.variant.s, st.frame); }, true);

    /* ---------- quantité ---------- */
    var qIn = $('[data-ap-qty-input]');
    function setQty(n) { st.qty = Math.max(1, Math.min(99, n | 0 || 1)); if (qIn) qIn.value = st.qty; update(); }
    $$('[data-ap-qty]').forEach(function (b) { b.addEventListener('click', function () { setQty(st.qty + +b.dataset.apQty); }); });
    if (qIn) qIn.addEventListener('change', function () { setQty(+qIn.value); });

    /* ---------- description « Voir plus » ---------- */
    $$('[data-ap-desc]').forEach(function (box) {
      var btn = box.querySelector('.ap-desc__toggle'), sh = box.querySelector('.ap-desc__short'), full = box.querySelector('.ap-desc__full');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = full.hidden; full.hidden = !open; sh.hidden = open;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- date de réception : 5 à 7 jours ouvrés ---------- */
    function addBusiness(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var eta = $('[data-ap-eta-txt]');
    if (eta && S.eta) {
      var lang = document.documentElement.lang || cfg.lang || 'fr';
      var f = function (d) { try { return d.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { return d.toDateString(); } };
      var now = new Date();
      eta.innerHTML = sub(S.eta, f(addBusiness(now, 5)), f(addBusiness(now, 7)));
    }

    /* ---------- galerie ---------- */
    var gal = $('[data-ap-gal]'), stage = gal && $('[data-ap-stage]', gal);
    var views = stage ? $$('[data-ap-view]', stage) : [];
    var N = views.length;
    function showMedia(mediaId) {
      var i = views.findIndex(function (v) { return v.dataset.mediaId === String(mediaId); });
      if (i > -1) showView(i);
    }
    function viewLabel(i) {
      var v = views[i]; if (!v) return '';
      if (v.hasAttribute('data-ap-main')) return st.frame ? sub(S.frame_label, frameName(st.frame)) : S.poster_label;
      return v.dataset.apLabel || '';
    }
    function paintGallery() {
      if (!stage) return;
      stage.classList.toggle('is-wall', st.wall);
      stage.classList.toggle('is-zoomable', !st.wall && mode === 'poster');
      stage.classList.remove('is-zoom');
      views.forEach(function (e, i) { e.classList.toggle('is-on', !st.wall && i === st.view); });
      $$('[data-ap-thumbs] button', gal).forEach(function (b) {
        var on = b.dataset.mode ? st.wall : (!st.wall && +b.dataset.v === st.view);
        b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      $$('.ap-mode button', stage).forEach(function (b) {
        var on = (b.dataset.mode === 'wall') === st.wall; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var l = $('[data-ap-vlbl]', stage); if (l) { l.textContent = viewLabel(st.view); l.hidden = !l.textContent; }
      var c = $('[data-ap-vcount]', stage); if (c) c.textContent = (st.view + 1) + ' / ' + N;
      galFoot();
    }
    /* vues cachées chargées à la demande (vue affichée + suivante) */
    function loadView(i) {
      var v = views[(i + N) % N]; if (!v) return;
      v.querySelectorAll('img[data-src]').forEach(function (im) { if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); });
    }
    function showView(i) { if (!N) return; st.view = (i + N) % N; st.wall = false; loadView(st.view); loadView(st.view + 1); paintGallery(); }
    var wallLoaded = false;
    function setWall(on) {
      st.wall = !!on;
      if (on && !wallLoaded) {
        wallLoaded = true;
        $$('.ap-scene img[data-src]', stage).forEach(function (im) { im.srcset = im.dataset.srcset; im.src = im.dataset.src; });
        /* le poster au mur = copie du poster de la vue 1 (même image, déjà en cache) */
        var src = $('[data-ap-main] .ap-fp', stage);
        $$('.ap-wp', stage).forEach(function (wp) {
          if (wp.firstElementChild || !src) return;
          var c = src.cloneNode(true); c.querySelectorAll('img').forEach(function (im) { im.removeAttribute('fetchpriority'); im.alt = ''; im.sizes = '200px'; });
          wp.appendChild(c); AP.setCadre(st.frame, wp);
        });
      }
      paintGallery(); if (on) renderWall();
    }
    function wallInfo() {
      var d = dimsOf(st.variant.s), c = SCENES[st.scene], framed = !!st.frame;
      var ow = framed ? d[0] / 0.9037 : d[0], oh = framed ? d[1] / 0.93 : d[0] * 400 / 283;
      return { pw: d[0], ph: d[1], ow: ow, oh: oh, framed: framed, c: c, cover: Math.round(ow / c.w * 100) };
    }
    function renderWall() {
      if (mode !== 'poster' || !stage) return;
      var w = wallInfo(), c = w.c, v = c.k * 16 / 9;
      $$('.ap-scene', stage).forEach(function (e) { e.classList.toggle('is-on', +e.dataset.sc === st.scene); });
      var sc = $('.ap-scene[data-sc="' + st.scene + '"]', stage); if (!sc) return;
      var wp = $('.ap-wp', sc), bottom = 100 - c.top + c.gap * v;
      wp.style.left = c.cx + '%'; wp.style.width = (w.ow * c.k) + '%'; wp.style.bottom = bottom + '%';
      var dt = $('.ap-dimtag', sc);
      dt.textContent = st.variant.s.toUpperCase() + ' · ' + w.pw + NB + '×' + NB + w.ph + NB + 'cm' + (w.framed ? ' · ' + S.wall_tag_framed : '');
      dt.style.left = c.cx + '%'; dt.style.bottom = (100 - c.top + c.gap * v / 2) + '%';
      var rs = $('[data-ap-room-size]', stage);
      if (rs) rs.innerHTML = cfg.variants.map(function (x) {
        var on = x.s === st.variant.s; return '<button type="button" data-sz="' + x.s + '" class="' + (on ? 'is-on' : '') + '" aria-pressed="' + on + '">' + x.s.toUpperCase() + '</button>';
      }).join('');
      $$('[data-ap-room-scene] button', stage).forEach(function (b) { var on = +b.dataset.scene === st.scene; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var room = $('[data-ap-room]', stage); if (room) room.setAttribute('aria-label', sub(S.wall_aria, st.variant.s.toUpperCase(), w.pw + '×' + w.ph, S.scene_refs[st.scene]));
    }
    function galFoot() {
      var f = gal && $('[data-ap-galfoot]', gal); if (!f) return;
      if (mode !== 'poster') { f.textContent = N > 1 && !matchMedia('(min-width:901px)').matches ? sub(S.hint_mobile, N) : ''; return; }
      if (st.wall) {
        var w = wallInfo();
        f.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 17 17 3l4 4L7 21H3z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/></svg><span>' +
          sub(S.wall_foot, S.scene_refs[st.scene], Math.round(w.ow) + NB + '×' + NB + Math.round(w.oh) + NB + 'cm' + (w.framed ? ' ' + S.wall_framed : ''), w.cover + NB + '%') + '</span>';
      } else {
        f.innerHTML = '<span>' + (matchMedia('(min-width:901px)').matches ? sub(S.hint_desktop, N) : sub(S.hint_mobile, N)) + '</span>';
      }
    }
    if (stage) {
      SCENES.forEach(function (c, i) {
        var e = $('.ap-scene[data-sc="' + i + '"]', stage); if (!e) return;
        var w = c.h * 1.25 * 16 / 9; /* galerie 4:5, scène 16:9 → largeur en % de la galerie */
        e.style.height = c.h + '%'; e.style.width = w + '%'; e.style.left = (50 - w * c.cx / 100) + '%'; e.style.setProperty('--wall', c.wall);
      });
      if (N <= 1) $$('.ap-arr,[data-ap-vcount]', stage).forEach(function (e) { e.hidden = true; });
      if (N <= 1 && mode !== 'poster') { var th = $('[data-ap-thumbs]', gal); if (th) th.hidden = true; }
      $('[data-ap-thumbs]', gal).addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.dataset.mode) setWall(true); else showView(+b.dataset.v);
      });
      stage.addEventListener('click', function (e) {
        var s = e.target.closest('button[data-step]'); if (s) { showView(st.view + +s.dataset.step); return; }
        var m = e.target.closest('button[data-mode]'); if (m && stage.contains(m)) { setWall(m.dataset.mode === 'wall'); return; }
        var z = e.target.closest('button[data-sz]'); if (z) { var inp = sizeInput(z.dataset.sz); if (inp && !inp.checked) inp.click(); return; }
        var c = e.target.closest('button[data-scene]'); if (c) { st.scene = +c.dataset.scene; renderWall(); galFoot(); return; }
        if (stage.classList.contains('is-zoomable') && !e.target.closest('.ap-ov') && matchMedia('(min-width:901px)').matches) stage.classList.toggle('is-zoom');
      });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('is-zoom')) return;
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width * 100, y = (e.clientY - r.top) / r.height * 100;
        $$('.ap-v.is-on>img,.ap-v.is-on .ap-fp', stage).forEach(function (el) { el.style.transformOrigin = x + '% ' + y + '%'; });
      });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
      var tx = null, ty = null;
      stage.addEventListener('touchstart', function (e) { tx = st.wall ? null : e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showView(st.view + (dx < 0 ? 1 : -1));
        tx = null;
      });
      $$('[data-ap-wall-open]').forEach(function (b) {
        b.addEventListener('click', function () { setWall(true); if (innerWidth <= 900) stage.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      });
      paintGallery();
    }

    /* ---------- poster personnalisé : orientation, aperçu de l'image importée (Uploadly), résolution ---------- */
    var perso = { img: null, w: 0, h: 0, paint: function () {} };
    if (mode === 'perso') {
      var poster = $('[data-ap-cr-poster]'), art = $('[data-ap-cr-art]'), frameImg = $('[data-ap-cr-frame]');
      var orientIn = form && form.querySelector('[data-ap-prop-orient]');
      var MIN = { m: [1170, 1654], l: [1654, 2339] };
      perso.paint = function () {
        var k = st.variant.s, d = dimsOf(k), land = st.orient === 'l';
        poster.classList.toggle('is-l', k !== 'm'); poster.classList.toggle('is-land', land);
        poster.classList.toggle('has-frame', !!st.frame);
        if (st.frame) {
          frameImg.src = AP.frameUrl(st.frame);
          /* le cadre (592×814, fenêtre 90,37 % × 93 %) entoure le poster ; tourné de 90° en paysage */
          frameImg.style.width = land ? (100 / 0.93) + '%' : (100 / 0.9037) + '%';
          frameImg.style.left = '50%'; frameImg.style.top = '50%';
          frameImg.style.transform = 'translate(-50%,-50%)' + (land ? ' rotate(90deg)' : '');
          if (land) { frameImg.style.width = (poster.offsetHeight / 0.9037) + 'px'; }
        }
        var sizeTxt = k.toUpperCase() + ' · ' + (land ? d[1] + NB + '×' + NB + d[0] : d[0] + NB + '×' + NB + d[1]) + NB + 'cm';
        $$('[data-ap-cr-tag-size],[data-ap-sum-size]').forEach(function (e) { e.textContent = sizeTxt; });
        $$('[data-ap-cr-tag-frame],[data-ap-sum-frame]').forEach(function (e) { e.textContent = frameName(st.frame); });
        $$('[data-ap-sum-orient]').forEach(function (e) { e.textContent = land ? S.landscape : S.portrait; });
        $$('[data-ap-orient]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.apOrient === st.orient ? 'true' : 'false'); });
        if (orientIn) orientIn.value = land ? 'Paysage' : 'Portrait';
        /* qualité : seuils M ≥ 1170×1654 px, L ≥ 1654×2339 px (côtés comparés sans tenir compte du sens) */
        var q = $('[data-ap-qual]'), qt = $('[data-ap-qual-txt]');
        if (q) {
          q.classList.remove('is-ok', 'is-mid', 'is-bad');
          if (!perso.w) { qt.textContent = S.q_wait; }
          else {
            var a = Math.min(perso.w, perso.h), b = Math.max(perso.w, perso.h), need = MIN[k] || MIN.m;
            var okSize = a >= need[0] && b >= need[1], okM = a >= MIN.m[0] && b >= MIN.m[1];
            var dimTxt = perso.w + NB + '×' + NB + perso.h + NB + 'px';
            if (okSize) { q.classList.add('is-ok'); qt.textContent = sub(S.q_ok, dimTxt, k.toUpperCase()); }
            else if (okM) { q.classList.add('is-mid'); qt.textContent = sub(S.q_mid, dimTxt); }
            else { q.classList.add('is-bad'); qt.textContent = sub(S.q_bad, dimTxt); }
          }
        }
        var s1 = $('[data-ap-step="1"]'); if (s1) s1.classList.toggle('is-done', !!perso.img);
        $$('[data-ap-sum-img]').forEach(function (e) { e.textContent = perso.img ? S.img_ok : S.img_none; });
      };
      $$('[data-ap-orient]').forEach(function (b) { b.addEventListener('click', function () { st.orient = b.dataset.apOrient; update(); }); });
      /* Uploadly (Uploadcare) ajoute, après l'envoi, un élément [data-img-id=<uuid>] avec un input contenant l'URL du fichier */
      var seen = '';
      function readUpload() {
        var holder = document.querySelector('[data-img-id]');
        if (!holder) {
          if (perso.img) { perso.img = null; perso.w = perso.h = 0; var oi = art.querySelector('img'); if (oi) oi.remove(); art.querySelector('.ap-cr-empty').hidden = false; update(); }
          return;
        }
        var uuid = holder.getAttribute('data-img-id');
        if (uuid === seen) return; seen = uuid;
        var inp = holder.querySelector('input[value^="http"]') || document.querySelector('input[name^="properties["][value*="' + uuid + '"]');
        var url = inp ? inp.value.split('?')[0] : 'https://ucarecdn.com/' + uuid + '/';
        perso.img = url;
        var show = function (w, h) {
          perso.w = w; perso.h = h;
          if (w && h && w > h && st.orient === 'p') st.orient = 'l';
          update();
        };
        fetch('https://ucarecdn.com/' + uuid + '/-/json/').then(function (r) { return r.json(); })
          .then(function (j) { show(j.width || 0, j.height || 0); })
          .catch(function () { var im = new Image(); im.onload = function () { show(im.naturalWidth, im.naturalHeight); }; im.src = url; });
        var pv = art.querySelector('img') || document.createElement('img');
        pv.alt = ''; pv.src = /ucarecdn/.test(url) ? url.replace(/\/?$/, '/') + '-/preview/1000x1000/' : url;
        pv.onerror = function () { pv.src = url; pv.onerror = null; };
        art.appendChild(pv); art.querySelector('.ap-cr-empty').hidden = true;
        update();
      }
      /* boutons de l'app Uploadly (libellés anglais réglés dans l'app) : traduits par nos clés */
      function relabel() {
        $$('.ap-upl .uploadcare--widget__button_type_open').forEach(function (b) {
          var t = perso.img ? S.upl_change : S.upl_btn;
          if (t && b.textContent !== t) b.textContent = t;
        });
      }
      new MutationObserver(function () { readUpload(); relabel(); }).observe(document.body, { childList: true, subtree: true });
      relabel();
      /* sans image importée : ajout BLOQUÉ (sinon un poster perso vide part au panier et se paie), message clair à l'étape 1
         et sous le bouton. Capture sur le bouton (avant Globo) et sur le formulaire (Entrée, barre collante). */
      var need = $('[data-ap-need-img]');
      var block = function (e) {
        if (perso.img || document.querySelector('[data-img-id]')) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (need) need.hidden = false;
        var w = form && form.querySelector('.product-form__error-message-wrapper'), m = w && w.querySelector('.product-form__error-message');
        if (w && m && S.need_img) { m.textContent = S.need_img; w.hidden = false; w.removeAttribute('hidden'); }
        var s1 = $('[data-ap-step="1"]');
        if (s1) s1.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var ob = $('.ap-upl .uploadcare--widget__button_type_open'); if (ob) setTimeout(function () { ob.focus({ preventScroll: true }); }, 400);
      };
      if (addBtn) addBtn.addEventListener('click', block, true);
      if (form) form.addEventListener('submit', block, true);
      document.addEventListener('ap:pdp', function () {
        if (!perso.img) return;
        if (need) need.hidden = true;
        var w = form && form.querySelector('.product-form__error-message-wrapper'), m = w && w.querySelector('.product-form__error-message');
        if (w && m && m.textContent === S.need_img) { m.textContent = ''; w.hidden = true; }
      });
      window.addEventListener('resize', function () { if (st.orient === 'l') perso.paint(); });
    }

    /* ---------- barre d'achat collante (section sticky-add-to-cart) ---------- */
    var sticky = document.querySelector('[data-ap-sticky]');
    if (sticky && addBtn) {
      /* position recalculée au défilement (rAF) : un IntersectionObserver ne voit pas un saut direct de « au-dessus » à
         « en dessous » du bouton (retour en haut instantané) et laissait la barre affichée en haut de page */
      var foot = document.querySelector('footer, .footer, [id*="__footer"]'), shown = null, raf = 0;
      var sync = function () {
        raf = 0;
        var past = addBtn.getBoundingClientRect().bottom < 0;
        var atFoot = foot ? foot.getBoundingClientRect().top < innerHeight : false;
        var show = past && !atFoot;
        if (show === shown) return; shown = show;
        sticky.classList.toggle('is-show', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      };
      var req = function () { if (!raf) raf = requestAnimationFrame(sync); };
      addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); sync();
      var sAdd = sticky.querySelector('[data-ap-sb-add]'), sOpt = sticky.querySelector('[data-ap-sb-opts]');
      if (sAdd) sAdd.addEventListener('click', function () { addBtn.click(); });
      if (sOpt) sOpt.addEventListener('click', function () { var t = $('variant-selects') || addBtn; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      document.addEventListener('ap:pdp', function (e) {
        var d = e.detail, p = sticky.querySelector('[data-ap-sb-price]'), ds = sticky.querySelector('[data-ap-sb-desc]');
        if (p) p.textContent = money(d.unit * d.qty);
        if (ds) ds.textContent = posterish ? d.variant.s.toUpperCase() + ' · ' + frameName(d.frame) : (d.variant.t || '');
        if (posterish) AP.setCadre(d.frame, sticky);
      });
    }

    /* état initial (cadre éventuel passé dans l'URL : ?cadre=noir) */
    if (st.frame && mode === 'poster') $$('[data-ap-main],[data-ap-tmain],.ap-wp').forEach(function (r) { AP.setCadre(st.frame, r); });
    if (st.frame) applyFrame();
    update();
  }

  /* ---------- « Compléter votre mur » : ce poster + 2 de la même collection, au format et au cadre choisis ---------- */
  function initWall(sec) {
    var data = JSON.parse(sec.querySelector('[data-ap-cw-data]').textContent);
    var S = decode(data.str), pool = data.items, me = null, cur = { size: 'm', frame: '' };
    if (!pool.length) { sec.hidden = true; return; }
    var picks = [0, Math.min(1, pool.length - 1)], keep = [true, true], next = 2;
    if (pool.length < 2) { picks = [0]; keep = [true]; }
    var $ = function (s) { return sec.querySelector(s); };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var framed = function (img, cls) {
      return '<span class="ap-fp ap-sq ' + (cur.frame ? '' : 'ap-fp-none ') + (cls || '') + '" data-poster-encadre><span class="ap-fp-win"><img class="ap-fp-art" src="' + img + '" alt="" loading="lazy" width="300" height="300"></span>' +
        (cur.frame ? '<img class="ap-fp-frame" src="' + AP.frameUrl(cur.frame) + '" alt="" aria-hidden="true" width="592" height="814" loading="lazy">' : '') + '</span>';
    };
    function lineFor(x) {
      var v = x.v[cur.size]; if (!v) return null;
      return { id: v[0], p: v[1] + fp(cur.size, cur.frame) };
    }
    function render() {
      if (!me) return;
      var items = [{ x: me, me: true, on: true }].concat(picks.map(function (pi, i) { return { x: pool[pi], on: keep[i], i: i }; }));
      var sel = items.filter(function (o) { return o.on && lineFor(o.x); });
      var prices = sel.map(function (o) { return lineFor(o.x).p; }), subt = prices.reduce(function (a, b) { return a + b; }, 0);
      var free = sel.length >= 3 ? Math.min.apply(null, prices) : 0;
      var freeIdx = -1; if (free) items.forEach(function (o, k) { if (o.on && freeIdx < 0 && lineFor(o.x).p === free && !o.me) freeIdx = k; });
      if (free && freeIdx < 0) freeIdx = 0;
      var order = items.length === 3 ? [items[1], items[0], items[2]] : items;
      $('[data-ap-cw-wall]').innerHTML = order.map(function (o) {
        return '<div class="ap-bwi' + (o.me ? ' is-me' : '') + (o.on ? '' : ' is-out') + '">' + framed(o.x.img) + (items.indexOf(o) === freeIdx ? '<span class="ap-off">' + esc(S.free_badge) + '</span>' : '') + '</div>';
      }).join('');
      var sz = cur.size.toUpperCase(), fn = frameName(cur.frame);
      $('[data-ap-cw-list]').innerHTML = items.map(function (o) {
        var l = lineFor(o.x), pr = l ? money(l.p) : '';
        return '<div class="ap-bitem"><label class="ap-bchk"><input type="checkbox"' + (o.on ? ' checked' : '') + (o.me ? ' disabled' : '') + ' data-keep="' + (o.me ? '' : o.i) + '" aria-label="' + esc(sub(S.include, o.x.t)) + '"></label>' +
          '<span class="ap-bimg">' + framed(o.x.img) + '</span><div style="min-width:0"><a href="' + o.x.u + '">' + esc(o.x.t) + '</a><span class="ap-xs">' + sz + ' · ' + esc(fn) + ' · ' + pr + '</span></div>' +
          (o.me ? '<span class="ap-me">' + esc(S.this_one) + '</span>' : (pool.length > 2 ? '<button class="ap-swap" type="button" data-swap="' + o.i + '" aria-label="' + esc(S.change) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7L21 8M21 3v5h-5"/></svg><span>' + esc(S.change) + '</span></button>' : '')) + '</div>';
      }).join('');
      $('[data-ap-cw-sum]').innerHTML = '<div><span class="ap-muted">' + esc(sub(S.n_posters, sel.length, sz, fn.toLowerCase())) + '</span><span>' + money(subt) + '</span></div>' +
        (free ? '<div class="ap-free"><span>' + esc(S.free_line) + '</span><span>−' + money(free) + '</span></div>' : '<div class="ap-muted"><span>' + esc(S.check_hint) + '</span><span></span></div>') +
        '<div class="ap-tot"><span>' + esc(S.total) + '</span><span>' + (free ? '<s>' + money(subt) + '</s>' : '') + money(subt - free) + '</span></div>';
      var btn = $('[data-ap-cw-add]');
      btn.querySelector('span').textContent = sub(S.add_n, sel.length);
      $('[data-ap-cw-note]').textContent = S.note;
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-swap]'); if (!b) return;
      var i = +b.dataset.swap, used = picks.slice();
      for (var t = 0; t < pool.length; t++) { var c = (next + t) % pool.length; if (used.indexOf(c) < 0) { picks[i] = c; next = c + 1; break; } }
      render();
    });
    sec.addEventListener('change', function (e) {
      var c = e.target.closest('[data-keep]'); if (c && c.dataset.keep !== '') { keep[+c.dataset.keep] = c.checked; render(); }
    });
    $('[data-ap-cw-add]').addEventListener('click', function () {
      var btn = this, err = $('[data-ap-cw-err]');
      var items = [me].concat(picks.filter(function (p, i) { return keep[i]; }).map(function (p) { return pool[p]; }));
      var lines = items.map(function (x) { var l = lineFor(x); return l ? { id: l.id, qty: 1, size: cur.size, frame: cur.frame } : null; }).filter(Boolean);
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true; if (err) err.textContent = '';
      AP.addItems(lines).catch(function (e) { if (err) err.textContent = e.message || S.error; })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
    });
    /* rien n'est construit (ni image chargée) avant que la section approche de l'écran */
    var near = false;
    me = { t: data.self.t, u: data.self.u, img: data.self.img, v: data.self.v };
    document.addEventListener('ap:pdp', function (e) { cur.size = e.detail.size; cur.frame = e.detail.frame; if (near) render(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { near = true; io.disconnect(); render(); } }, { rootMargin: '300px 0px' });
      io.observe(sec);
    } else { near = true; render(); }
  }

  function boot() {
    /* « Compléter votre mur » d'abord : il écoute l'événement ap:pdp émis à l'initialisation de la fiche */
    document.querySelectorAll('[data-ap-cw]').forEach(function (s) { try { initWall(s); } catch (e) { console.error(e); } });
    document.querySelectorAll('[data-ap-pdp]').forEach(function (r) { try { initPdp(r); } catch (e) { console.error(e); } });
  }
  /* « Vous aimerez aussi » : flèches du rail (contenu chargé après coup par product-recommendations → délégation) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ap-rail-step]'); if (!b) return;
    var sec = b.closest('[data-ap-rail]'), rail = sec && sec.querySelector('.ap-scroll-x');
    if (rail) rail.scrollBy({ left: +b.dataset.apRailStep * rail.clientWidth * 0.8, behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
